import SideMenu from "../../features/sideMenu/SideMenu";
import { itemsSoporte } from "../../constants/soporte";

const SoporteDashboard = ({ API_URL, user }) => {
  return (
    <div className="rs-container" style={{ display: "flex", width: "100%" }}>
      <div className="rs-sidebar" style={{ width: "12rem" }}>
        <SideMenu items={itemsSoporte} className="rs-sidemenu" />
      </div>
      <div
        className="rs-content"
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
        }}
      >
        Contenido
      </div>
    </div>
  );
};

export default SoporteDashboard;
